/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Twitter',
  definitions: {
    '32': {
      viewBox: '0 0 31 26',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.5616 6.88333C27.5725 7.14754 27.5787 7.41332 27.5787 7.68065C27.5787 15.8124 21.3884 25.1875 10.068 25.1875C6.59204 25.1875 3.35699 24.1695 0.631836 22.4241C1.11375 22.48 1.60344 22.5096 2.1009 22.5096C4.98462 22.5096 7.63826 21.5257 9.7447 19.8751C7.05064 19.8254 4.77786 18.0458 3.99592 15.601C4.37057 15.6741 4.7561 15.7129 5.15251 15.7129C5.71371 15.7129 6.25781 15.6368 6.77392 15.4969C3.95861 14.9311 1.83818 12.4444 1.83818 9.46335C1.83818 9.43693 1.83818 9.4105 1.83818 9.38564C2.66832 9.84569 3.6166 10.1223 4.62551 10.155C2.97457 9.05148 1.88792 7.16775 1.88792 5.03379C1.88792 3.90542 2.19106 2.84854 2.72117 1.93932C5.75724 5.6617 10.2919 8.11272 15.4064 8.36917C15.3023 7.91844 15.2479 7.44907 15.2479 6.9657C15.2479 3.56815 18.0025 0.8125 21.4024 0.8125C23.173 0.8125 24.7727 1.56009 25.8951 2.75684C27.2973 2.48019 28.614 1.96885 29.8033 1.26323C29.3447 2.69934 28.3684 3.90542 27.0968 4.66699C28.342 4.51934 29.5281 4.18829 30.6318 3.69871C29.8064 4.93277 28.7632 6.01606 27.5616 6.88333Z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
